import { fromJS, Map } from 'immutable';
import {
    GET_ALL_QUIZZES_SUCCESS,
    GET_QUIZ_SUCCESS,
    UPDATE_QUIZ_SUCCESS,
    CREATE_QUIZ_SUCCESS,
    CLEAR_CREATED_QUIZ,
    CLEAR_QUIZZES,
    DELETE_QUIZ_SUCCESS,
    UPDATE_QUIZ_INTRO_SUCCESS,
    UPDATE_QUIZ_INTRO_SETTINGS_SUCCESS,
    UPDATE_QUIZ_REGISTRATION_SUCCESS,
    UPDATE_QUIZ_REGISTRATION_SETTINGS_SUCCESS,
    UPDATE_QUIZ_RESULT_SUCCESS,
    UPDATE_QUESTION_DRAG_DROP_SUCCESS,
    UPDATE_QUIZ_RESULT_SETTINGS_SUCCESS,
    FILTER_QUIZZES_SUCCESS,
    CHANGE_STATUS_SUCCESS,
    GET_TENANT_STATISTIC_SUCCESS,
    DUPLICATE_QUIZ_SUCCESS,
    ERASE_QUIZ_SUCCESS
} from './constants';

import { CREATE_TEXT_ANSWER_SUCCESS } from './questions/text/constants';

import {
    UPDATE_QUESTION_SUCCESS,
    UPLOAD_QUESTION_COVER_SUCCESS,
    DELETE_QUESTION_COVER_SUCCESS,
    UPDATE_QUESTION_FEEDBACK_SETTINGS_SUCCESS,
    CREATE_QUESTION_SUCCESS,
    DELETE_QUESTION_SUCCESS,
    HIDE_QUESTION_SUCCESS,
    PIN_QUESTION_SUCCESS,
    COPY_QUESTION_SUCCESS
} from './questions/constants';

import {
    CREATE_ANSWER_SUCCESS,
    UPDATE_ANSWER_SUCCESS,
    DELETE_ANSWER_SUCCESS,
    BIND_TYPE_TO_ANSWER_SUCCESS
} from './answers/constants';
import { CREATE_TYPE_SUCCESS, UPDATE_TYPE_SUCCESS, DELETE_TYPE_SUCCESS } from './types/constants';

import { UPDATE_QUESTION_FEEDBACK_SUCCESS } from '../../data/quiz/questions/constants';

import {
    PUT_DIPLOMA_SUCCCESS,
    POST_DIPLOMA_SUCCCESS,
    GET_DIPLOMA_SUCCCESS,
    DELETE_DIPLOMA_SUCCCESS
} from '../diploma/constants';

//todo нужно протестировать
const getLang = () => {
    if ( typeof window !== 'undefined' && typeof localStorage !== 'undefined' ) {
        return localStorage?.getItem( 'lang' ) === null ? 'en' : localStorage?.getItem( 'lang' );
    } else {
        return '';
    }
};


const quizzesRedObject = {
    data: {},
    language: { value: 'English' }
};
/**
 *
 * @param state
 * @param action
 * @returns {{data: {}, language: {value: string}}|{data: {}, language: {value: string}}|{data: (*|Map|Set), language: {value: string}}|{data: {}, language: {value: string}, tenant_statistic: *}|{perPage: (number|*), data: *, lastPage: *, language: {value: string}, currentPage: *}|{data: {}, language: {value: string}}|{data: {}, createdQuiz: null, language: {value: string}}|{data, createdQuiz: *, language: {value: string}}|{perPage: (number|*), data, lastPage: *, language: {value: string}, currentPage: *}}
 */
const quizzesReducer = ( state = quizzesRedObject, action ) => {

    switch ( action.type ) {
        case FILTER_QUIZZES_SUCCESS: {
            const newState = { ...state };
            const quizzes = action.quizzes;

            if ( !quizzes.data.length === 0 ) {
                return newState;
            }

            const quizzesObj = {};
            quizzes.data.reverse().map( item => quizzesObj[ item.id ] = item );
            return {
                ...newState,
                data: { ...quizzesObj },
                perPage:
                    quizzes.current_page + 1 === quizzes.last_page
                        ? quizzes.total - quizzes.to
                        : quizzes.per_page,
                currentPage: quizzes.current_page,
                lastPage: quizzes.last_page
            };

        }
        case GET_ALL_QUIZZES_SUCCESS: {

            const newState = { ...state };
            const quizzes = action.quizzes;
            if ( !quizzes.data.length === 0 ) {
                return newState;
            }
            const quizzesObj = {};
            quizzes.data.map( item => quizzesObj[ item.id ] = item );
            return {
                ...newState,
                data: { ...newState.data, ...quizzesObj },
                perPage:
                    quizzes.current_page + 1 === quizzes.last_page
                        ? quizzes.total - quizzes.to
                        : quizzes.per_page,
                currentPage: quizzes.current_page,
                lastPage: quizzes.last_page
            };
        }
        case CREATE_QUIZ_SUCCESS: {
            const newState = { ...state };
            const newQuiz = { [ action.quiz.id ]: action.quiz };
            return {
                ...newState,
                data: { ...newState.data, ...newQuiz },
                createdQuiz: action.quiz.quiz_localization[ 0 ].id
            };
        }
        case DUPLICATE_QUIZ_SUCCESS: {
            const newState = { ...state };
            const newQuiz = { [ action.quizess.id ]: action.quizess };

            return { ...newState, data: { ...newState.data, ...newQuiz }, createdQuiz: action.quizess.id };
        }
        case CLEAR_CREATED_QUIZ: {
            return {
                ...state,
                createdQuiz: null
            };
        }
        case DELETE_QUIZ_SUCCESS: {
            const newStateData = { ...state.data };
            delete newStateData[ action.quizID ];
            return { ...state, data: newStateData };
        }
        case CHANGE_STATUS_SUCCESS: {
            const quiz = state.data;
            const oldQuizzes = Object.keys( quiz ).map( i => quiz[ i ] );
            const quizAction = action.quiz[ 0 ];

            const immutableQuiz = fromJS( oldQuizzes );
            const indexOfQuiz = immutableQuiz.findIndex(
                quiz => quiz.get( 'id' ) == quizAction.id
            );
            const updatedQuiz = immutableQuiz.set( indexOfQuiz, Map( quizAction ) );
            return { ...state, data: updatedQuiz.toJS() };
        }
        case GET_TENANT_STATISTIC_SUCCESS: {
            return { ...state, tenant_statistic: action.statistics };
        }
        case CLEAR_QUIZZES:
            return quizzesRedObject;
        default:
            return state;
    }
};


const initialQuizState = {
    questions: [],
    lang: getLang()
};
/**
 *
 * @param state
 * @param action
 * @returns {{questions: *[], lastQuestion: *, lang: string|string|null}|{questions: (*|Map|Set), lang: string|string|null}|{questions: [], lang: (string|string)}|{questions: (*|Map|Set), lang: string|string|null, quiz_localization: (*|Map|Set)}|{questions: *, lang: string|string|null}|{questions: [], lang: string|string|null, quiz_localization: {[p: string]: *}}|{questions: [], lang: string|string|null}|{questions: [], lang: string|string|null, quiz_localization: *}}
 */
const quizReducer = ( state = initialQuizState, action ) => {

    switch ( action.type ) {

        case UPDATE_QUESTION_DRAG_DROP_SUCCESS : {
            return { ...state, questions: action.newQuestions };
        }

        case ERASE_QUIZ_SUCCESS : {
            state = {
                questions: [],
                lang: getLang()
            };
            return state ;
        }

        case UPDATE_QUIZ_INTRO_SUCCESS:
        case UPDATE_QUIZ_REGISTRATION_SUCCESS:
        case UPDATE_QUIZ_RESULT_SUCCESS:
        case GET_QUIZ_SUCCESS:
            return { ...state, ...action.quiz };

        case UPDATE_QUIZ_INTRO_SETTINGS_SUCCESS: {

            return { ...state, quiz_localization: action.quiz };
        }
        case UPDATE_QUIZ_REGISTRATION_SETTINGS_SUCCESS: {

            return { ...state, quiz_localization: action.quiz };
        }
        //TODO
        case UPDATE_QUIZ_RESULT_SETTINGS_SUCCESS: {
            return { ...state, quiz_localization: action.quiz };
        }
        case UPDATE_QUIZ_SUCCESS: {
            return { ...state, ...action.updatedQuizPiece };
        }

        case CREATE_QUESTION_SUCCESS:
        case COPY_QUESTION_SUCCESS: {
            const updatedQuestions = [ ...state.questions, action.newQuestion ];
            return { ...state, questions: updatedQuestions, lastQuestion: action.newQuestion };
        }

        case CREATE_TEXT_ANSWER_SUCCESS: {
            let immutableQuestions = fromJS( state.questions );
            const indexOfQuestion = immutableQuestions.findIndex(
                question => question.get( 'id' ) == action.questionID
            );
            immutableQuestions = immutableQuestions.updateIn(
                [ indexOfQuestion, 'answers' ],
                answers => answers.push( new Map( action.newAnswer ) )
            );
            return { ...state, questions: immutableQuestions.toJS() };
        }

        case UPDATE_QUESTION_SUCCESS: {
            const immutableQuestions = fromJS( state.questions );
            const indexOfQuestion = immutableQuestions.findIndex(
                question => question.get( 'id' ) == action.questionID
            );
            const updatedQuestion = Map( immutableQuestions.get( indexOfQuestion ) ).merge( Map( action.updatedQuestionPiece ) );
            const mergedQuestions = immutableQuestions.set( indexOfQuestion, Map( updatedQuestion ) );
            return { ...state, questions: mergedQuestions.toJS() };
        }

        case UPLOAD_QUESTION_COVER_SUCCESS:
        case DELETE_QUESTION_COVER_SUCCESS:
        case HIDE_QUESTION_SUCCESS:
        case PIN_QUESTION_SUCCESS: {
            const immutableQuestions = fromJS( state.questions );
            const indexOfQuestion = immutableQuestions.findIndex(
                question => question.get( 'id' ) == action.questionID
            );
            const updatedQuestion = immutableQuestions.set( indexOfQuestion, Map( action.question ) );
            return { ...state, questions: updatedQuestion.toJS() };
        }

        case UPDATE_QUESTION_FEEDBACK_SETTINGS_SUCCESS: {


            const immutableQuestions = fromJS( state.questions );
            const indexOfQuestion = immutableQuestions.findIndex(
                question => question.get( 'id' ) == action.questionID
            );

            const updatedQuestion = immutableQuestions.setIn( [ indexOfQuestion, 'localization', 'feedback_settings' ], Map( action.question ) )

            return { ...state, questions: updatedQuestion.toJS() };
        }
        case UPDATE_QUESTION_FEEDBACK_SUCCESS: {

            let immutableQuestions = fromJS( state.questions );
            const indexOfQuestion = state.questions.findIndex( question => question.id == action.question.question_id );
            const updatedQuestions = immutableQuestions.toJS();
            updatedQuestions[ indexOfQuestion ].localization = action.question;

            return { ...state, questions: updatedQuestions };
        }

        case CREATE_ANSWER_SUCCESS:
        case UPDATE_ANSWER_SUCCESS:
        case DELETE_ANSWER_SUCCESS:
        case BIND_TYPE_TO_ANSWER_SUCCESS: {
            const immutableQuestions = fromJS( state.questions );
            const indexOfQuestion = immutableQuestions.findIndex( question => question.get( 'id' ) === action.questionID );
            const updatedQuestion = immutableQuestions.setIn( [ indexOfQuestion, 'localization' ], Map( action.question ) );
            return { ...state, questions: updatedQuestion.toJS() };
        }
        case DELETE_QUESTION_SUCCESS: {
            const immutableQuestions = fromJS( state.questions );

            const updatedQuestion = immutableQuestions.filter( el => el.get( 'id' ) !== action.questionID );
            return { ...state, questions: updatedQuestion.toJS() };
        }

        case CREATE_TYPE_SUCCESS:
        case UPDATE_TYPE_SUCCESS:
        case DELETE_TYPE_SUCCESS: {
            const immutableQuizLocalization = fromJS( action.quiz.quiz_localization );
            const immutableQuestions = fromJS( action.quiz.questions );
            return {
                ...state,
                quiz_localization: immutableQuizLocalization.toJS(),
                questions: immutableQuestions.toJS()
            };
        }

        case DELETE_DIPLOMA_SUCCCESS:
        case GET_DIPLOMA_SUCCCESS:
        case PUT_DIPLOMA_SUCCCESS:

        case POST_DIPLOMA_SUCCCESS: {
            const quiz_localization = { ...state.quiz_localization, diplom: { ...action.result } };
            return { ...state, quiz_localization: { ...quiz_localization } };
        }

        default:
            return state;
    }
};


export { quizzesReducer as quizzes, quizReducer as quiz };
